<template>
  <div class="oderss" v-if="maikeinfo.courseInfo!=undefined">
    <headers />
    <div class="containers">
      <div class="project">
        <div class="order">
          确认订单信息
          <!-- <span>
            请在
            <h6>30分钟</h6>内完成支付！超出可能导致购买失败，需重新下单
          </span>-->
        </div>

        <div class="details">
          <div class="information">商品信息</div>
          <div class="course">
            <img :src="maikeinfo.courseInfo!=undefined && maikeinfo.courseInfo.imgUrl" />

            <div class="name" v-if="maikeinfo.courseInfo!=undefined">
              {{maikeinfo.courseInfo.title}}
              <span v-if="maikeinfo.courseInfo.type == 1">点播课</span>
              <span v-if="maikeinfo.courseInfo.type == 2">直播课</span>
              <span v-if="maikeinfo.courseInfo.type == 3">线下课</span>
            </div>
            <div class="num">
              总价
              <span>¥{{maikeinfo.courseInfo!=undefined && maikeinfo.courseInfo.price}}</span>
            </div>
            <div class="clear"></div>
          </div>

          <div class="coupon">
            <div class="you clearfix">
              <span class="el-dropdown-link" @click="show3 = !show3">
                使用优惠券（
                <em
                  v-if="maikeinfo.couponInfo!=undefined && maikeinfo.couponInfo.length == 0"
                >0</em>
                <em v-else>{{maikeinfo.couponInfo!=undefined && maikeinfo.couponInfo.length}}</em>
                张可用）
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <div class="instrout">优惠券说明？</div>
            </div>
          </div>
          <div class="clear"></div>
          <el-collapse-transition>
            <div
              slot="dropdown"
              class="dropdownbox clearfix"
              v-if="show3 && maikeinfo.couponInfo!=undefined && maikeinfo.couponInfo.length != 0"
            >
              <div v-for="(item,index) in maikeinfo.couponInfo" :key="item.id" :data-id="item.id">
                <div class="items">
                  <div class="ts">
                    <div class="name">{{item.title}}</div>
                    <div class="nums" v-if="item.type == 1">
                      <i>￥</i>
                      {{item.limit}}
                    </div>
                    <div class="nums" v-if="item.type == 2">
                      {{item.limit}}
                      <i>折</i>
                    </div>
                    <div class="time">有效期：{{item.start_time}} 至 {{item.end_time}}</div>
                    <div class="ht"></div>
                  </div>
                  <div class="bs clearfix">
                    <div class="num fl">满￥{{item.maxprice}}可用</div>
                  </div>
                  <el-radio v-model="radio" :label="index" class="radiomodel"></el-radio>
                </div>
              </div>
              <el-button
                type="danger"
                style="width:100%;margin-bottom:16px;"
                @click="noyouhui"
              >不使用优惠券</el-button>
            </div>
          </el-collapse-transition>
          <div class="payment">支付方式</div>
          <div class="payway">

            <div :class="['zfb', 'fl', 'box', active==0?'active':'']" @click="active = 0" v-if="maikeinfo.joinType.indexOf(1)>=0">
              <img class="padding12" src="http://web.wit100.net/yunmipcimg/003_03.png" />
              <em class="ion el-icon-check"></em>
            </div>

            <div :class="['weichat', 'fl', 'box',active==1?'active':'']" @click="active = 1" v-if="maikeinfo.joinType.indexOf(2)>=0">
              <img class="padding5" src="http://web.wit100.net/yunmipcimg/01-01-03_05.png" />
              <em class="ion el-icon-check"></em>
            </div>

            <div class="money fl box" :class="[ active==2?'active':'']" @click="active = 2" v-if="maikeinfo.joinType.indexOf(3)>=0">
              <img
                class="padding10"
                style="width:40px"
                src="http://web.wit100.net/yunmipcimg/003_04.png"
              />
              <div class="wallet">
                <span>钱包余额</span>
                <i>¥{{maikeinfo.balance}}</i>
              </div>
              <em class="ion el-icon-check"></em>
            </div>

            <div class="clear"></div>
          </div>

          <div class="paymoney fr">
            <div class="discount">
              优惠券
              <i v-if="max == 0" style="font-size:16px;font-weight: bold;">
                <em v-if="radio == null">不使用优惠券</em>
                <em v-else>暂无可用的优惠券</em>
              </i>
              <i v-else>-￥{{max}}</i>
            </div>
            <h3>
              实付金额
              <i>¥{{heji}}</i>
            </h3>
            <h6>
              <el-checkbox v-model="checked"></el-checkbox>我已同意
              <router-link
                tag="i"
                :to="{path:'/agreement',query:{key:maikeinfo.joinSingleKey}}"
              >《平台购课协议》</router-link>
            </h6>
            <span class="fr" @click="payfunc">立即支付</span>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <el-dialog title="请输入密码" width="30%" :visible.sync="qianbaoshow" :show-close="false">
      <div class="mima">
        <van-password-input :value="value" info="密码为 6 位数字" :focused="autofocus" @click="jvjiao" />
        <router-link tag="span" :to="{path:'/settings/paypassword',query:{index:2}}">忘记密码</router-link>
      </div>

      <el-input
        class="inputbox"
        placeholder="请输入密码"
        v-model="value"
        show-password
        :autofocus="autofocus"
        @blur="autofocus = false"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qianbaoshow = false">取 消</el-button>
        <el-button type="primary" @click="qianbaozhifu">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付宝支付" :visible.sync="zhifubaoqueren" width="443px" class="paysbox" style="margin-top:16vh;">
      <p>
        请在打开的页面完成支付，
        <span>支付完成前，请不要关闭此窗口。</span>
      </p>
      <div class="btns">
        <span @click="orderthree(false)">已完成支付</span>
        <span class="on" @click="orderthree(false)">支付遇到问题</span>
      </div>
    </el-dialog>
    <el-dialog
      title="微信支付"
      :visible.sync="weixinqueren"
      width="443px"
      :before-close="handleClose"
      class="paysbox"
    >
      <p>请使用微信扫码支付</p>
      <div class="code">
        <Qrcode :msg="link" class="code_img"></Qrcode>
      </div>
    </el-dialog>
    <footers />
  </div>
  
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import {
  Icon,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Radio,
  Checkbox,
  Dialog,
  MessageBox,
  Input,
  Button,
  Message
} from "element-ui";
import { PasswordInput } from "vant";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
let Dec = require("decimal.js");
import Qrcode from "@/components/Qrcode.vue";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
export default {
  components: {
    headers,
    footers,
    Qrcode,
    [Icon.name]: Icon,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [MessageBox.name]: MessageBox,
    [PasswordInput.name]: PasswordInput,
    [Input.name]: Input,
    [Button.name]: Button,
    [Message.name]: Message,
    [CollapseTransition.name]: CollapseTransition
  },
  data() {
    return {
      radio: 0,
      checked: true,
      active: 0,
      zhifubaoqueren: false,
      weixinqueren: false,
      qianbaoshow: false,
      isSetPayPwd: null,
      maikeinfo: {},
      max: 0, //优惠的金额 算出来会出现三位这时候用总价减去最终价格得出来
      value: "",
      showKeyboard: true,
      xiala: true, //默认允许优惠券下拉
      orderid: null, //买课id
      link: null,
      show3: false,
      autofocus: false,
      timeout: null //定时查询
    };
  },
  filters: {
    toFixed(money) {
      return money.toFixed(1);
    }
  },
  watch: {
    radio(newvalue) {
      if (this.radio == null) {
        //不是用优惠券
      } else {
        let a = this.maikeinfo.courseInfo.price;
        let b = this.heji;
        this.show3 = false;
        this.max = new Dec(a).sub(new Dec(b)).toNumber();
      }
    },
    qianbaoshow() {
      if (this.qianbaoshow == false) {
        this.autofocus = false;
      }
    },
    weixinqueren() {
      if (this.weixinqueren == false) {
        clearInterval(this.timeout);
      }
    }
  },
  computed: {
    heji() {
      var zuizhong = null;
      if (
        (this.maikeinfo.couponInfo && this.maikeinfo.couponInfo.length == 0) ||
        this.radio == null
      ) {
        zuizhong = this.maikeinfo.courseInfo.price;
        this.max = 0;
      } else {
        if (
          this.maikeinfo.courseInfo != undefined &&
          this.maikeinfo.couponInfo != undefined
        ) {
          let a = this.maikeinfo.courseInfo.price;
          let b = this.maikeinfo.couponInfo[this.radio].limit;

          if (this.maikeinfo.couponInfo[this.radio].type == 1) {
            //直接优惠
            zuizhong = new Dec(a).sub(b).toNumber();
          } else {
            //打折卷
            zuizhong = new Dec(a).mul(new Dec(b) * 0.1).toNumber();
          }
        }
      }

      return getPointNum.getPointNum(zuizhong, 2) <= 0
        ? 0
        : getPointNum.getPointNum(zuizhong, 2);
    }
  },
  methods: {
    jvjiao() {
      this.autofocus = true;
      this.$nextTick(x => {
        //正确写法
        document.querySelector(".inputbox .el-input__inner").focus();
      });
    },
    handleClose(done) {
      MessageBox.confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
    },
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },

    noyouhui() {
      //未使用优惠券
      this.show3 = false;
      this.radio = null;
    },

    zhifupay() {
      // 判断是否设置了支付密码

      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        this.isSetPayPwd = JSON.parse(
          utilFile.decrypt(res.data.data)
        ).isSetPayPwd;
      });
    },
    orderthree(wx) {
      //第三方接口校验 支付是否成功
      var data = utilFile.encrypt(
        JSON.stringify({
          id: localStorage.makeid,
          pay_type: "video"
        })
      );
      this.$axios({
        method: "post",
        url: `/api/join.checkResult?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          let obj = JSON.parse(utilFile.decrypt(res.data.data));
          if (obj.result == 0) {
            if (wx == true) {
            } else {
              Message.closeAll();
              Message({
                message: "支付失败 或者未支付",
                type: "warning"
              });
              setTimeout(() => {
                this.$router.replace({ path: "/orderview" });
              }, 1000);
            }
          } else {
            Message.closeAll();
            //成功
            Message({
              message: "支付成功",
              type: "success"
            });
            clearInterval(this.timeout);
            setTimeout(() => {
              this.$router.replace({ path: "/orderview" });
            }, 1000);
          }
        } else {
          Message.closeAll();
          Message({
            message: res.data.msg,
            type: "warning"
          });
          setTimeout(() => {
            this.$router.replace({ path: "/orderview" });
          }, 1000);
        }

        localStorage.removeItem("showpopup"); //订单页  微信h5支付 引导用户是否支付完成的弹窗
      });
    },
    shaixuanjuan() {
      //筛选出最合适的优惠券
      let juanlist = this.maikeinfo.couponInfo;
      let price = this.maikeinfo.courseInfo.price;
      let jinelist = [];
      juanlist.forEach((item, index) => {
        if (item.type == 1) {
          jinelist[index] = item.limit;
        } else {
          var a = getPointNum.getPointNum(
            new Dec(price)
              .sub(new Dec(price).mul(new Dec(item.limit * 0.1)))
              .toNumber(),
            2
          );
          jinelist[index] = a;
        }
      });
      this.max = jinelist[0];
      for (var i = 1; i < jinelist.length; i++) {
        var cur = jinelist[i];
        cur > this.max ? (this.max = cur) : null;
      }
      this.radio = jinelist.indexOf(this.max);
    },
    async payfunc() {
      if (this.checked) {
        if (this.heji == 0) {
          //通过优惠券等于零元 直接生成订单 买课信息 跳转支付成功页面
          await this.makedingdan(); //生成买课订单
          this.$router.replace({
            path: "/orderview"
          });
        } else {
          //立即支付
          if (localStorage.makeid) {
            //如果有了买课订单就不要在调用买课订单函数了 同时禁止选用优惠券
            this.orderid = localStorage.makeid;
            this.xiala = false; //false禁止优惠券下拉
          } else {
            await this.makedingdan(); //生成买课订单
          }
          if (this.active == 0) {
            //支付宝支付
            await this.zhifubaopay();
          } else if (this.active == 1) {
            //微信支付
            await this.wxpay();
            this.timeout = setInterval(() => {
              this.$globel.loding = true;
              this.orderthree(true);
            }, 1000);
          } else if (this.active == 2) {
            if (this.isSetPayPwd == 0) {
              Message.closeAll();
              Message({
                showClose: true,
                message: "未设置支付密码",
                type: "warning"
              });
              setTimeout(() => {
                this.$router.push({
                  path: "/settings/paypassword",
                  query: {
                    index: "2"
                  }
                });
              }, 1000);

            } else {
              //余额支付
              this.qianbaoshow = true;
            }
          }
        }
      } else {
        Message.closeAll();
        Message({
          message: "请勾选协议",
          type: "warning"
        });
      }
    },
    wxpay() {
      //微信支付

      var data = utilFile.encrypt(
        JSON.stringify({
          id: localStorage.makeid,
          pay_from: "pc",
          pay_type: "video"
        })
      );
      this.$axios({
        method: "post",
        url: `/api/join.wxpay?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.link = totaldata;
        this.weixinqueren = true;
      });
    },
    zhifubaopay() {
      //支付宝支付
      localStorage.setItem("baoid", this.orderid);
      localStorage.setItem("showpopup", true);
      this.$router.push({ path: "/baopay" });
      this.dialogVisible = true;
    },
    qianbaozhifu() {
      if (this.value.length == 6) {
        //钱包支付
        var data = utilFile.encrypt(
          JSON.stringify({
            id: localStorage.makeid,
            paypwd: this.value
          })
        );

        this.$axios({
          method: "post",
          url: `/api/join.balace?parameter=${data}`,
          data: data,
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        }).then(res => {
          if (res.data.code == 200) {
            let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
            this.qianbaoshow = false;
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/orderview"
              });
            }, 1000);
          } else {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "warning"
            });
          }
        });
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "请输入支付密码",
          type: "warning"
        });
      }
    },
    async makedingdan() {
      //生成买课订单
      var data = utilFile.encrypt(
        JSON.stringify({
          courseId: this.$route.query.id ? this.$route.query.id : "",
          sectionId: this.$route.query.keid ? this.$route.query.keid : "",
          courseType: this.maikeinfo.courseInfo.type,
          couponId:
            this.maikeinfo.couponInfo.length == 0 || this.radio == null
              ? ""
              : this.maikeinfo.couponInfo[this.radio].id,
          money: this.heji
        })
      );

      await this.$axios({
        method: "post",
        url: `/api/join.create?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.orderid = totaldata.id;
        localStorage.setItem("makeid", totaldata.id); //缓存买课订单
        this.show3 = ""; //这个生成买课订单后禁止再次选用优惠券
      });
    },
    maike() {
      var data = utilFile.encrypt(
        JSON.stringify({
          courseId: this.$route.query.id ? this.$route.query.id : "",
          sectionId: this.$route.query.keid ? this.$route.query.keid : ""
        })
      );
      this.$axios({
        method: "post",
        url: `/api/join.info?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        }
        this.maikeinfo = JSON.parse(utilFile.decrypt(res.data.data));

        if(this.maikeinfo.joinType.indexOf(1) >=0){
          this.active = 0;
        }else if(this.maikeinfo.joinType.indexOf(2) >=0){
          this.active = 1;
        }
       else if(this.maikeinfo.joinType.indexOf(3) >=0){
          this.active = 2;
        }

        if (this.maikeinfo.couponInfo.length != 0) {
          this.shaixuanjuan(); //筛选出最合适的优惠券
        }
      });
    }
  },
  mounted() {
    this.zhifupay();
    this.maike();
    if (localStorage.showpopup) {
      this.zhifubaoqueren = true;
    }
  }
};
</script>

<style scoped>
.project {
  margin: 0 auto;
}
.project .order {
  display: block;
  height: 65px;
  line-height: 65px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}
.order span {
  margin-left: 20px;
  font-size: 14px;
  font-weight: bolder;
  color: #434242;
}
.order span h6 {
  color: #f00;
  font-size: 14px;
  font-weight: bolder;
  margin: 0;
  display: inline-block;
  cursor: pointer;
}
.project .details {

  background-color: #ffffff;
  width: 100%;
  height: auto;
  padding: 35px;
  border-radius: 15px;
  box-shadow: 10px 10px 10px;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
  margin-bottom: 60px;

}
.project .details .information {
  font-size: 15px;
  margin-bottom: 24px;
  width: 100%;
  text-align: left;
  font-weight: bold;
}
.project .details .course {
  background-color: #f3f5f7;
  display: block;
  padding: 30px;
  position: relative;
}
.project .details .course img {
  float: left;
  width: 130px;
}
.project .details .course .name {
  margin-left: 20px;
  float: left;
  font-size: 15px;
}
.project .details .course .name span {
  display: block;
  margin-top: 52px;
  color: #9b9b9b;
  text-align: left;
}
.project .details .course .num {
  font-size: 15px;
  right: 30px;
  color: #9b9b9b;
  position: absolute;
  bottom: 30px;
}
.project .details .course .num span {
  color: #ff0000;
  margin-left: 20px;
  font-weight: bolder;
  font-size: 18px;
}
.clear {
  clear: both;
}
.project .details .coupon {
  margin-top: 30px;
  margin-bottom: 35px;
  font-size: 18px;
  float: left;
  border: 1px solid #eeeeee;
  border-width: 1px 0;
  width: 100%;
  line-height: 60px;
  text-align: left;
  cursor: pointer;
}
.project .details .coupon ul {
  padding-right: 155px;
}
.project .details .coupon li {
  position: relative;
  width: 31%;
  line-height: 0;
  margin-right: 3%;
  margin-bottom: 20px;
}
.project .details .coupon li:nth-of-type(3n) {
  margin-right: 0;
}
.project .details .coupon li span {
  position: absolute;
  top: 0;
  left: 20px;
  color: #ffffff;
  margin: 0;
  font-size: 16px;
  line-height: 45px;
}

.bottom {
  font-size: 14px;
  bottom: 0;
  top: unset !important;
  color: #000 !important;
}
.fz14 {
  font-size: 14px;
  top: 70px !important;
}
.fz18 {
  font-size: 18px;
  top: 40px !important;
}
.fz30 {
  font-size: 30px;
  display: inline-block;
  margin-left: 5px;
}
.project .details .coupon li span .py {
}
.project .details .coupon li img {
  box-shadow: 10px 10px 10px;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.05);
}
.project .details .coupon span {
  font-size: 14px;
}
.project .details .coupon span em {
  color: #ff0000;
  font-weight: bolder;
}

.project .details .coupon span i {
  color: #000;
}

.iconfont {
  font-size: 24px !important;
  color: #9b9b9b;
}
.project .details .coupon .explain {
  float: right;
  font-size: 14px;
}
.project .details .payment {
  font-size: 15px;
  font-weight: bolder;
  margin-bottom: 25px;
  text-align: left;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.box {
  background-color: #f3f5f7;
  margin-right: 15px;
  padding: 30px;
  border-radius: 10px;
  height: 106px;
  box-sizing: border-box;
}
.padding5 {
  padding: 0 5px;
}
.padding12 {
  padding: 0 12px;
}
.padding10 {
  padding: 0 10.93px;
}
.money .wallet {
  height: 100%;
  display: inline-block;
}
.money .wallet span {
  font-size: 18px;
  display: block;
}
.money .wallet i {
  font-size: 14px;
  color: #9b9b9b;
}

.payway em {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 20px;
  color: #ffffff;
  z-index: 100;
  display: none;
}

.payway .active {
  border-style: solid;
  border-width: 2px;
  border-color: #f00;
  position: relative;
}

.payway .active::after {
  width: 0;
  content: "";
  height: 0;
  border-style: solid;
  border-width: 0 0 30px 40px;
  border-color: transparent transparent #ff0e0e transparent;
  position: absolute;
  bottom: 0;
  right: 0;
}

.payway .active em {
  display: block;
}

.payway img {
  display: inline-block;
}

.paymoney {
  display: block;
  text-align: right;
  margin-right: 10px;
}

.paymoney i {
  display: inline-block;
  width: 150px;
  text-align: right;
}

.paymoney h3 {
  display: inline-block;
  font-size: 18px;
  color: #666666;
  font-weight: normal;
  margin-right: 6px;
  margin-bottom: 20px;
}
.paymoney h3 i {
  color: #f00;
  font-size: 24px;
  font-weight: bolder;
  width: 147px;
  text-align: right;
}
.paymoney h6 {
  text-align: right;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}
.paymoney h6 i {
  color: #38a0ff;
  font-size: 12px;
  cursor: pointer;
}
.paymoney span {
  text-align: center;
  line-height: 50px;
  margin-top: 40px;
  height: 50px;
  width: 182px;
  display: block;
  font-size: 16px;
  background-color: #38a0ff;
  color: #ffffff;
  cursor: pointer;
}

.paymoney .discount {
  font-size: 18px;
  color: #6d6d6d;
  text-align: right;
  margin-bottom: 19px;
}

.paymoney .discount i {
  font-size: 24px;
  color: #ff0e0e;
}

.ticket {
  box-sizing: border-box;
  padding: 0 30px;
}

.items {
  width: 300px;
  float: left;
  margin-right: 23px;
  margin-bottom: 20px;
  border-radius: 6px;
  position: relative;
}

.items:nth-of-type(3n) {
  margin-right: 0;
}

.items .ts {
  background-image: linear-gradient(to right, #42aeff, #2087ed);
  background-image: -moz-linear-gradient(to right, #42aeff, #2087ed);
  background-image: -ms-linear-gradient(to right, #42aeff, #2087ed);
  background-image: -webkit-linear-gradient(to right, #42aeff, #2087ed);
  box-sizing: border-box;
  padding-left: 16px;
  text-align: left;
  overflow: hidden;
  position: relative;
  line-height: 1em;
}

.items .ts::after {
  width: 12px;
  content: "";
  height: 12px;
  background-color: #ffffff;
  position: absolute;
  left: -6px;
  bottom: -6px;
  border-radius: 50%;
  z-index: 1000;
}

.items .ts::before {
  width: 12px;
  content: "";
  height: 12px;
  background-color: #ffffff;
  position: absolute;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
  z-index: 1000;
}

.items .ts .name {
  font-size: 16px;
  color: #ffffff;
  margin-top: 16px;
  margin-bottom: 20px;
}

.items .ts .nums {
  font-size: 30px;
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 13px;
}

.items .ts .time {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 16px;
}

.items .ts .nums i {
  font-size: 18px;
}

.items .bs {
  box-sizing: border-box;
  padding: 0 16px;
  position: relative;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
}

.items .bs::before {
  width: calc(100% - 12px);
  content: "";
  height: 0;
  border: 0.5px dashed #238bef;
  position: absolute;
  top: 0;
  left: 6px;
  z-index: 10;
}

.items .bs .num {
  font-size: 14px;
  color: #000000;
  line-height: 46px;
}

.items .bs .ling {
  float: right;
  font-size: 18px;
  color: #238bef;
  text-decoration: underline;
  line-height: 46px;
}

.radios {
  appearance: none;
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50%;
  position: relative;
}

.radios::after {
  width: 100%;
  content: "";
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.radios:checked::after {
  content: "\e6da";
}

.el-dropdown {
  display: block;
  text-align: left;
}

.demonstration {
  width: 100%;
  text-align: left;
  display: block;
}

.payway {
  cursor: pointer;
}

.el-popper[x-placement^="bottom"] {
  left: 50% !important;
  width: 1126px !important;
  margin-left: -563px;
}

.mima {
  position: relative;
  cursor: pointer;
}

.mima span {
  margin-top: 16px;
  font-size: 14px;
  color: #969799;
  position: absolute;
  right: 16px;
  bottom: 0;
}
</style>
<style>
.paymoney h6 .el-checkbox__input {
  margin-right: 8px;
}

.you .el-dropdown-link {
  float: left;
}

.instrout {
  float: right;
  font-size: 14px;
  color: #505354;
}

.el-dropdown-menu__item {
  float: left;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ffffff;
  color: #000000;
}
.radiomodel {
  position: absolute;
  top: 14px;
  right: 14px;
  font-size: 0;
}

.radiomodel .el-radio__label {
  font-size: 0;
}

.radiomodel .el-radio__inner {
  width: 30px;
  height: 30px;
  background-color: #ffffff;
}

.radiomodel .el-radio__input.is-checked .el-radio__inner {
  background-color: #ffffff;
  background-image: url("~@/assets/images/duihao_03.png");
  background-repeat: no-repeat;
  background-size: 80% auto;
  background-position: center;
}

.dropdownbox {
}

.inputbox {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1px;
}
.van-password-input__info {
  text-align: left;
}
.paysbox .el-dialog__header {
  text-align: left;
  padding-bottom: 20px;
  padding-top: 20px;
  background-color: #f8f8f8;
  font-size: 13px;
  line-height: 1em;
}
.paysbox .el-dialog__headerbtn {
  top: 22px;
}

.paysbox .el-dialog {
  border-radius: 6px;
  overflow: hidden;
}

.paysbox .el-dialog__title {
  font-size: 12px;
}

.paysbox p {
  font-size: 14px;
  color: #000;
  margin: 44px 0;
}

.paysbox p span {
  color: red;
}

.paysbox .btns {
  text-align: center;
  font-size: 0;
  margin-bottom: 30px;
  cursor: pointer;
}

.paysbox .btns span {
  display: inline-block;
  width: 174px;
  line-height: 40px;
  color: #ffffff;
  border-radius: 6px;
  text-align: center;
  margin: 0 5px;
  background-color: #38a0ff;
  font-size: 14px;
}
.paysbox .btns span.on {
  background-color: #9fa5ad;
}

.paysbox .el-dialog__body {
  padding: 0;
}

.paysbox .code {
  width: 182px;
  border-radius: 6px;
  overflow: hidden;
  padding: 15px;
  border: 1px solid #e4e5e7;
  margin: auto;
  margin-bottom: 64px;
}
</style>